import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-availability-settings',
  templateUrl: './availability-settings.component.html',
  styleUrls: ['./availability-settings.component.scss']
})
export class AvailabilitySettingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
